var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChart = function SvgChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M28.893 9.266c-.853-2.893-3.266-5.306-6.16-6.16-2.2-.64-3.72-.586-4.773.2-1.267.947-1.413 2.654-1.413 3.867v3.32c0 3.28 1.493 4.947 4.426 4.947H24.8c1.2 0 2.92-.147 3.867-1.414.813-1.04.88-2.56.226-4.76"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25.213 17.813a1.82 1.82 0 0 0-1.373-.627h-4.773a4.256 4.256 0 0 1-4.254-4.253V8.159c0-.52-.226-1.026-.626-1.373a1.8 1.8 0 0 0-1.427-.44c-3.133.4-6.013 2.12-7.893 4.707-1.894 2.6-2.587 5.773-1.987 8.946.867 4.587 4.533 8.254 9.133 9.12a11 11 0 0 0 2.2.214c2.414 0 4.747-.747 6.734-2.2 2.586-1.88 4.306-4.76 4.706-7.894a1.8 1.8 0 0 0-.44-1.426",
    opacity: 0.35
  })));
};
export default SvgChart;